import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'initials' })
export class InitialsPipe implements PipeTransform {
    transform(name: string = ''): string {
        return name
            .split(' ')
            .map((word) => word.charAt(0))
            .join('')
            .toUpperCase();
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/_shared/initials.pipe.ts